// useSelectedPlot.tsx
import { create } from 'zustand'

const useSelectedPlot = create((set) => ({
  selectedPlot: null,
  setSelectedPlot: (selectedPlot: any) => set({ selectedPlot }),

  //set focused plot
  focusedPlot: null,
  setFocusedPlot: (focusedPlot: any) => set({ focusedPlot }),
}))

export default useSelectedPlot
